import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "./baseQuery";

export const loteApi = createApi({
  reducerPath: "loteApi",
  baseQuery: baseQueryWithReauth,
  endpoints: (builder) => ({
    getLotes: builder.query({
      query: (params) => ({
        url: "lote/",
        params,
      }),
    }),
    getLoteById: builder.query({
      query: (loteId) => ({
        url: `lote/${loteId}`,
      }),
    }),
    createLote: builder.mutation({
      query: (newLote) => ({
        url: "lote",
        method: "POST",
        body: newLote,
      }),
    }),
    deleteLote: builder.mutation({
      query: (id) => ({
        url: `lote/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetLotesQuery,
  useGetLoteByIdQuery,
  useCreateLoteMutation,
  useDeleteLoteMutation,
} = loteApi;